<template>
  <div id="content" class="loginpage">
    <div class="container  text-center">

      <div class="row">
        <div class="col-12">
          <form class="login-form" >
            <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo mb-5" alt="">

            <div class="row mb-6">
            <div class="col-12 prelative">
                <input :type="inputtype" id="password"  name="password" placeholder="Set your password" v-model="input.password" />
                <button type="button" class="toggleView" @click="toggleView()" name="button">
                  <v-icon v-if="inputtype == 'password'" icon="mdi-eye-outline"></v-icon>
                  <v-icon v-if="inputtype == 'text'"  icon="mdi-eye-off-outline"></v-icon>
                </button>
                <small style="text-align:left !important;display:block;">Your password must be at least 10 characters long with an uppercase, a lowercase, a number and a special character</small>
                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.password.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.password.$errors" :key="index">{{ error.$message }}</div>
                </div>
            </div>
          </div>
          <div class="row mb-6">
          <div class="col-12 prelative">
              <input :type="inputtype2" id="password_confirmation" name="password_confirmation"  placeholder="Confirm password" v-model="input.password_confirm" />
              <button type="button" class="toggleView" @click="toggleView2()" name="button">
                <v-icon v-if="inputtype2 == 'password'" icon="mdi-eye-outline"></v-icon>
                <v-icon v-if="inputtype2 == 'text'"  icon="mdi-eye-off-outline"></v-icon>
              </button>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.password_confirm.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.password_confirm.$errors" :key="index">{{ error.$message }}</div>
              </div>
          </div>
        </div>

          <div class="row mb-6">
          <!-- <div class="col-12">
              <input type="text" id="username" placeholder="Username" v-model="input.username"/>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.username.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.username.$errors" :key="index">{{ error.$message }}</div>
              </div>
          </div> -->
        </div>

            <button class="btn next_step_btn" type="submit" v-on:click.prevent = "register_partial()">
            SET YOUR PASSWORD
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  </template>

<script>
 import {toast } from 'vue-sonner'
 import { useVuelidate } from '@vuelidate/core'
import { helpers,required,minLength,sameAs } from '@vuelidate/validators'


export default {
  name: 'RegisterConfirm',
  components: {

  },
  setup () {
   return { v$: useVuelidate() }
  },
  data(){
    return{
      inputtype:"password",
      inputtype2:"password",
      input:{
            password: "",
            password_confirm: "",
            // username: "",

        }
    }
  },
  validations () {
   return {
     input:{
       password: {
         required,
         min: minLength(10) ,
         containsPasswordRequirement: helpers.withMessage(
          () => `The password requires an uppercase, lowercase, number and special character`,
          //eslint-disable-next-line
          (value) =>  new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})").test(value)
        ),
       },
       password_confirm: {
         required,
         min: minLength(10),
         sameAs: helpers.withMessage("Passwords are not matching", sameAs(this.input.password))
      }, // Matches this.lastName
       // username: { required } // Matches this.contact.email
     }

   }
 },
  methods: {
    toggleView(){
      if(this.inputtype == "password")this.inputtype="text";
      else this.inputtype = "password";
    },
    toggleView2(){
      if(this.inputtype2 == "password")this.inputtype2="text";
      else this.inputtype2 = "password";
    },
    async register_partial(){
       const isFormCorrect = await this.v$.$validate()
      // alert(isFormCorrect);
       if(isFormCorrect){
         this.axios.post(process.env.VUE_APP_API_URL+"/register_confirm",{
           password: this.input.password,
           activator : this.$route.params.id
         },{
           headers: {
               'Content-Type': 'application/json',
           }
         }).then( () => {
           toast.success("Welcome to your Partner+ platform, "+this.input.username+"! Find, evaluate and manage portfolio of innovation partners with a systematic approach, technology and expertise more effectively than ever before. Choose where you'd like to begin.");
          this.$router.push('/login');
         }).catch( () => {
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ");
         })


       }


    }
  },
  mounted(){

      //this.$store.commit('LOGOUT')
  },
}
</script>
<style media="screen">
.loginpage{
  padding: 50px;
}
.loginpage form{
  background: #FFF;
  padding: 50px;
  border-radius: 20px;
  max-width: 800px;
margin: auto;
}

.loginpage form input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prelative{
  position:relative;
}
.toggleView{
  position: absolute;
  right: 20px;
  top: 5px;
}
</style>
